/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconLoading.vue?vue&type=template&id=93652946"
import script from "./IconLoading.vue?vue&type=script&lang=js"
export * from "./IconLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93652946')) {
      api.createRecord('93652946', component.options)
    } else {
      api.reload('93652946', component.options)
    }
    module.hot.accept("./IconLoading.vue?vue&type=template&id=93652946", function () {
      api.rerender('93652946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconLoading.vue"
export default component.exports